module.exports = __webpack_public_path__ + "img/12.4b8ea38f.png";